export default "__VITE_ASSET__DNu_Z$Wq__"